import React, { FC, memo } from 'react';
import { useCarDetailsDuck } from '@hooks/useCarDetailsDuck';
import { useSetImageQuality } from '@hooks/useSetImageQuality';
import { IOption } from '../../services/stock/models/stockItems.service.model';
import { ROLES } from 'src/constants/main';
import { ImageSize } from '@utils/Image.utils';

const CarGalleryListItem: FC<{ url: string; quality: ImageSize }> = memo(({ url, quality }) => {
    const { carDetails } = useCarDetailsDuck();
    const img = useSetImageQuality(url, quality);

    const imageAlt = `${carDetails?.model?.description} ${carDetails?.grBodyStyle?.description} ${
        carDetails?.exteriorColour?.title
    } ${carDetails?.interiorColour?.title}: ${carDetails?.options.map((option: IOption) => option.title)?.join(',')}`;

    return (
        <div className="image-wrapper" role={ROLES.IMG}>
            <img src={img} alt={imageAlt} />
        </div>
    );
});
CarGalleryListItem.displayName = 'CarGalleryImage';
export default CarGalleryListItem;
